import { get } from 'lodash';

export const isModalOpenSelector = state => Boolean( get( state, 'modal.type', false ) );
export const modalTypeSelector = state => get( state, 'modal.type', null );
export const modalAttributesSelector = state => get( state, 'modal.attributes', {} );
